export default "<ng-container #primaryContainer></ng-container>"